module.exports = __webpack_public_path__ + "static/media/spades.ec79c415.svg";